export default __webpack_public_path__ + "static/media/boxtype6.2e1a3952.JPG";